import { createPortal } from "react-dom";
import { useEnvironment } from "@aviv-unified-frontend/runtime/environment";

import { useShouldInitOverlay } from "../OverlayOrchestrator";

import { AdjustBanner } from "./AdjustBanner";
import { CustomBanner } from "./CustomBanner";

export const AppBanner = () => {
  const { isWebView } = useEnvironment();
  const shouldInitAdjustBanner = useShouldInitOverlay("adjust-banner");
  const shouldInitCustomBanner = useShouldInitOverlay("custom-banner");

  if (isWebView) return null;

  return (
    <>
      {shouldInitAdjustBanner && <AdjustBanner />}
      {shouldInitCustomBanner && createPortal(<CustomBanner />, document.body)}
    </>
  );
};
